/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.160.1-v202607082044-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqJobsApiClass {
 
   constructor() {}

  /**
   * @summary Create a job to capture a content screenshot at a regular interval
  */
  public createContentJob(
    body: string,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/jobs/content`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.JobOutputV1>;
  }

  /**
   * @summary Create a job to update a date range and its content at a regular interval
  */
  public createDateRangeJob(
    body: string,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/jobs/dateRange`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.JobOutputV1>;
  }

  /**
   * @summary Delete a scheduled job and cancel any currently running instance
   * @param {string} group - Group to which the job belongs
   * @param {string} id - ID of the job to delete
   * @param {string} [schedulerType=User] - Which scheduler to query for the job. The options are User (default), System, and AsyncMigration.
  */
  public deleteJob(
    {
      group,
      id,
      schedulerType
    } : {
      group: string,
      id: string,
      schedulerType?: SchedulerTypeEnum3
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (group === null || group === undefined) {
      throw new Error("'group' parameter required");
    }

    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/jobs/${encodeURIComponent(String(group))}/${encodeURIComponent(String(id))}`
      .replace('{group}', encodeURIComponent(String(group)))
      .replace('{id}', encodeURIComponent(String(id)));

    const queryParams = {
      ['schedulerType']: schedulerType
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Get details of a specified job
   * @param {string} group - Group to which the job belongs
   * @param {string} id - ID of the job to retrieve
   * @param {string} [schedulerType=User] - Which scheduler to query for the job. The options are User (default), System, and AsyncMigration.
  */
  public getJob(
    {
      group,
      id,
      schedulerType
    } : {
      group: string,
      id: string,
      schedulerType?: SchedulerTypeEnum1
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (group === null || group === undefined) {
      throw new Error("'group' parameter required");
    }

    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/jobs/${encodeURIComponent(String(group))}/${encodeURIComponent(String(id))}`
      .replace('{group}', encodeURIComponent(String(group)))
      .replace('{id}', encodeURIComponent(String(id)));

    const queryParams = {
      ['schedulerType']: schedulerType
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.JobOutputV1>;
  }

  /**
   * @summary List of scheduled jobs
   * @param {number} [offset=0] - The pagination offset, the index of the first job that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of jobs that will be returned in this page of results
   * @param {string} [schedulerType=User] - Which scheduler to query for jobs. The options are User (default), System, and AsyncMigration.
  */
  public getJobs(
    {
      offset,
      limit,
      schedulerType
    } : {
      offset?: number,
      limit?: number,
      schedulerType?: SchedulerTypeEnum2
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/jobs`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit,      ['schedulerType']: schedulerType
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.GetJobsOutputV1>;
  }

  /**
   * @summary A simplified endpoint for fetching a screenshot of Seeq content at a regular interval.
   * @param {string} id - The content id to capture
  */
  public getScreenshotFromContent(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/jobs/content/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ScreenshotOutputV1>;
  }

  /**
   * @summary Validate a list of Quartz cron expressions
  */
  public validateCron(
    body: models.ValidateCronListInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/jobs/validateCron`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ValidateCronListOutputV1>;
  }

}

export const SchedulerTypeEnum3 = {
    User: 'User',
    System: 'System',
    AsyncMigration: 'AsyncMigration'
} as const;

export type SchedulerTypeEnum3 = typeof SchedulerTypeEnum3[keyof typeof SchedulerTypeEnum3];
export const SchedulerTypeEnum1 = {
    User: 'User',
    System: 'System',
    AsyncMigration: 'AsyncMigration'
} as const;

export type SchedulerTypeEnum1 = typeof SchedulerTypeEnum1[keyof typeof SchedulerTypeEnum1];
export const SchedulerTypeEnum2 = {
    User: 'User',
    System: 'System',
    AsyncMigration: 'AsyncMigration'
} as const;

export type SchedulerTypeEnum2 = typeof SchedulerTypeEnum2[keyof typeof SchedulerTypeEnum2];

export const sqJobsApi = new sqJobsApiClass();

export type sqJobsApiEndpoints = {
  'createContentJob': {
    method: 'post';
    path: '/jobs/content';
    response: models.JobOutputV1;
  };
  'createDateRangeJob': {
    method: 'post';
    path: '/jobs/dateRange';
    response: models.JobOutputV1;
  };
  'deleteJob': {
    method: 'delete';
    path: '/jobs/${encodeURIComponent(String(group))}/${encodeURIComponent(String(id))}';
    response: models.StatusMessageBase;
  };
  'getJob': {
    method: 'get';
    path: '/jobs/${encodeURIComponent(String(group))}/${encodeURIComponent(String(id))}';
    response: models.JobOutputV1;
  };
  'getJobs': {
    method: 'get';
    path: '/jobs';
    response: models.GetJobsOutputV1;
  };
  'getScreenshotFromContent': {
    method: 'get';
    path: '/jobs/content/${encodeURIComponent(String(id))}';
    response: models.ScreenshotOutputV1;
  };
  'validateCron': {
    method: 'post';
    path: '/jobs/validateCron';
    response: models.ValidateCronListOutputV1;
  };
};

type ApiCreateContentJobResponse = models.JobOutputV1;
type ApicreateContentJobMutationParams = Parameters<typeof sqJobsApi.createContentJob> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqJobsApi.createContentJob>;
type ApicreateContentJobMutationVariables = string;

export function useApiCreateContentJobMutation(
  options?: Omit<UseMutationOptions<ApiCreateContentJobResponse, AxiosError<SeeqErrorData>,
    ApicreateContentJobMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateContentJobResponse, AxiosError<SeeqErrorData>,
  ApicreateContentJobMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateContentJobMutationVariables) =>
      sqJobsApi.createContentJob(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiCreateDateRangeJobResponse = models.JobOutputV1;
type ApicreateDateRangeJobMutationParams = Parameters<typeof sqJobsApi.createDateRangeJob> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqJobsApi.createDateRangeJob>;
type ApicreateDateRangeJobMutationVariables = string;

export function useApiCreateDateRangeJobMutation(
  options?: Omit<UseMutationOptions<ApiCreateDateRangeJobResponse, AxiosError<SeeqErrorData>,
    ApicreateDateRangeJobMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateDateRangeJobResponse, AxiosError<SeeqErrorData>,
  ApicreateDateRangeJobMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateDateRangeJobMutationVariables) =>
      sqJobsApi.createDateRangeJob(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiDeleteJobResponse = models.StatusMessageBase;
type ApideleteJobMutationParams = Parameters<typeof sqJobsApi.deleteJob> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqJobsApi.deleteJob>;

export function useApiDeleteJobMutation(
  options?: Omit<UseMutationOptions<ApiDeleteJobResponse, AxiosError<SeeqErrorData>,
    ApideleteJobMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteJobResponse, AxiosError<SeeqErrorData>,
  ApideleteJobMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteJobMutationParams) =>
      sqJobsApi.deleteJob(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetJobResponse = models.JobOutputV1;
export function GetJobQueryKey(
  params: Parameters<typeof sqJobsApi.getJob>[0],
) {
  return ['sqJobsApi', 'getJob', params] as const;
}

export function useApiGetJobQuery(
  params: Parameters<typeof sqJobsApi.getJob>[0],
  options?: Omit<UseQueryOptions<ApiGetJobResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetJobResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetJobQueryKey(params),
    queryFn: () =>
      sqJobsApi.getJob(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetJobsResponse = models.GetJobsOutputV1;
export function GetJobsQueryKey(
  params: Parameters<typeof sqJobsApi.getJobs>[0],
) {
  return ['sqJobsApi', 'getJobs', params] as const;
}

export function useApiGetJobsQuery(
  params: Parameters<typeof sqJobsApi.getJobs>[0],
  options?: Omit<UseQueryOptions<ApiGetJobsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetJobsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetJobsQueryKey(params),
    queryFn: () =>
      sqJobsApi.getJobs(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetScreenshotFromContentResponse = models.ScreenshotOutputV1;
export function GetScreenshotFromContentQueryKey(
  params: Parameters<typeof sqJobsApi.getScreenshotFromContent>[0],
) {
  return ['sqJobsApi', 'getScreenshotFromContent', params] as const;
}

export function useApiGetScreenshotFromContentQuery(
  params: Parameters<typeof sqJobsApi.getScreenshotFromContent>[0],
  options?: Omit<UseQueryOptions<ApiGetScreenshotFromContentResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetScreenshotFromContentResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetScreenshotFromContentQueryKey(params),
    queryFn: () =>
      sqJobsApi.getScreenshotFromContent(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiValidateCronResponse = models.ValidateCronListOutputV1;
type ApivalidateCronMutationParams = Parameters<typeof sqJobsApi.validateCron> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqJobsApi.validateCron>;
type ApivalidateCronMutationVariables = models.ValidateCronListInputV1;

export function useApiValidateCronMutation(
  options?: Omit<UseMutationOptions<ApiValidateCronResponse, AxiosError<SeeqErrorData>,
    ApivalidateCronMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiValidateCronResponse, AxiosError<SeeqErrorData>,
  ApivalidateCronMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApivalidateCronMutationVariables) =>
      sqJobsApi.validateCron(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
